import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function SubstationOverview() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 mt-5 bg-light" id="substation-overview">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold text-dark">⚡ SUBSTATION OVERVIEW</h2>
          <p className="text-muted">
            Substations are used to transform voltage levels, distribute power efficiently, and protect the electrical network. They serve as key nodes in power systems for industrial facilities, utilities, commercial complexes, and infrastructure projects.
          </p>
        </div>

        {/* Key Features */}
        <div className="mb-5" data-aos="fade-up">
          <h4 className="text-success mb-3">✨ Key Features</h4>
          <ul className="text-muted">
            <li>Indoor or outdoor compact design</li>
            <li>Includes transformers, HT/LT switchgear, RMU, and protection panels</li>
            <li>Custom-built for industrial, utility, or commercial use</li>
            <li>Built to IEC and BSTI standards</li>
            <li>Optional SCADA integration for remote monitoring</li>
          </ul>
        </div>

        {/* Ratings */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-primary mb-3">📏 Ratings</h4>
          <ul className="text-muted">
            <li><strong>Voltage Levels:</strong> 11kV / 33kV / 132kV (Customizable)</li>
            <li><strong>Transformer Capacity:</strong> 100 kVA to 20 MVA</li>
            <li><strong>Frequency:</strong> 50 Hz</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default SubstationOverview;
